import * as Yup from 'yup';

import type { InferType } from 'yup';

export const ProductSchema = Yup.object({
  name: Yup.string().required('El nombre es obligatorio'),
  display_name: Yup.string().required('El nombre para mostrar es obligatorio'),
  slug: Yup.string(),
  redeemable_region: Yup.string().required('La región de canje es obligatoria'),
  face_value: Yup.string().required('El valor nominal es obligatorio').min(0, 'El valor nominal debe ser mayor a 0'),
  selling_price: Yup.number().required('El precio de venta es obligatorio').min(0, 'El precio de venta debe ser mayor a 0'),
  selling_currency: Yup.string().required('La moneda de venta es obligatoria'),
  merchant_price: Yup.number().required('El precio del comerciante es obligatorio').min(0, 'El precio del comerciante debe ser mayor a 0'),
  merchant_currency: Yup.string().required('La moneda del comerciante es obligatoria'),
  commission: Yup.string().required('La comisión es obligatoria').min(0, 'La comisión debe ser mayor o igual a 0'),
  markup_percentage: Yup.string().required('El porcentaje de recargo o descuento es obligatorio'),
  in_stock: Yup.boolean().required('El stock es obligatorio'),
  visible: Yup.boolean().required('La visibilidad es obligatoria'),
  source: Yup.string().oneOf(['BonoxProduct', 'LocalProduct'], 'Fuente inválida').required('La fuente es obligatoria'),
  reference_id: Yup.number()
    .transform((value, original) => (original === '' || original === null || original === undefined ? 0 : value))
    .min(0, 'El ID de referencia debe ser mayor o igual a 0')
    .required('El ID de referencia es obligatorio'),
  image: Yup.string().required('La imagen es obligatoria').url('Debe ser una URL válida'),
  link: Yup.string().nullable(),
  link_text: Yup.string().nullable(),
  description: Yup.string().required('La descripción es obligatoria'),
  instructions: Yup.string().required('Las instrucciones son obligatorias'),
  category: Yup.string().required('La categoría es obligatoria'),
  order: Yup.number().required('El orden es obligatorio').min(0, 'El orden debe ser mayor o igual a 0'),
  required_level: Yup.number().nullable(),
  extra_data: Yup.object().nullable()
})

export type ProductData = InferType<typeof ProductSchema>;